import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { renderTextFieldCompact, renderSelectFieldCompact, renderTextField, renderSwitch, renderSelectField } from '../../shared/components/FormFields';
import { renderUploadButton } from '../../shared/components/FormFields';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import AttachmentIcon from '@material-ui/icons/Attachment';
import SendIcon from '@material-ui/icons/Send';
import {getFileNameFromUrl} from '../../shared/utils';
import MenuItem from '@material-ui/core/MenuItem';

const validate = values => {
  const errors = {}
  let requiredFields = [
    'first_name',
    'last_name',
    'email',
    'phone'
  ]

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  })
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }
  return errors
}

const required = value => value ? undefined : 'Required'; // field level validation func

export const phoneNumber = value =>
  value && !/^\d{3}[-\.\s]{0,3}\d{3}[-\s\.]{0,3}\d{4}$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined;

let ProfileForm = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;

  const renderFooter = () => {
    return <>
      <div style={{marginBottom: 20}}>
        <small>I accept <Link href='https://www.recruitvirtual.com/privacy-and-terms' rel="noopener" target='_blank'>Privacy and Terms of Service</Link></small>
      </div>
      <Button disabled={props.inProgress} style={{width: 120}} type="submit" variant="contained" color="primary" endIcon={ <SendIcon />} >
        Send
      </Button>
      </>;
  }

  const renderSelectQuestion = (name, label, q) => {
    return (
      <div key={name}>
        <Field name={name} component={renderSelectFieldCompact} label={label} fullWidth validate={q.is_required ? [ required ] : [] }  >
          {q.options.map( (opt) =>
          <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          )}
        </Field>
      </div>
    );
  };

  const renderTextQuestion = (name, label, q) => {
    return (
      <div key={name}>
        <Field name={name} component={renderTextFieldCompact} type="text" label={label} fullWidth validate={q.is_required ? [ required ] : [] }/>
      </div>
    );
  }

  const renderSwitchQuestion = (name, label, q) => {
    return (
      <div key={name}>
        <Field name={name} component={renderSwitch} type="text" label={label}  options={ { true: 'Yes', false: 'No'} } />
      </div>
    );
  }

  const renderQuestion = (q) => {
    let fieldName = `answers[question_${q.id}]`;
    let label = q.body;
    if( q.is_required ) label += ' *';
    if(q.question_type == 'Select' ) {
      return renderSelectQuestion(fieldName, label, q);
    }
    if(q.question_type == 'Text' ) {
      return renderTextQuestion(fieldName, label, q);
    }
    if(q.question_type == 'YesNo' ) {
      return renderSelectQuestion(fieldName, label, q);
    }
    return <>
    </>;
  };

  const renderEventQuestions = () => {
    return <>
      {props.questions.map( (q) => renderQuestion(q) )}
      </>;
  };

  return (
    <form onSubmit={handleSubmit} style={{minWidth: 270}}>
      <div>
        <Field name="first_name" component={renderTextField} type="text" label="First name *" fullWidth />
      </div>
      <div>
        <Field name="last_name" component={renderTextField} type="text" label="Last name *" fullWidth />
      </div>
      <div>
        <Field name="email" component={renderTextField} type="text" label="Email *" fullWidth />
      </div>
      <div style={{marginBottom: 10}}>
        <Field name="phone" component={renderTextField} type="text" label="Phone *" fullWidth validate={[phoneNumber]} />
      </div>
      <div style={{marginBottom: 10}}>
        { (props.profile && props.profile.resume && props.profile.resume.url) ?
        <Link style={{marginBottom: 10, display:'block'}} target='_blank' rel='noopener' href={props.profile.resume.url} >{getFileNameFromUrl(props.profile.resume.url)}</Link>
        : '' }
        <Field name="resume" component={renderUploadButton} type="text" label={ (props.profile && props.profile.resume && props.profile.resume.url) ? "Upload new resume" : "Attach Résumé" } startIcon={<AttachmentIcon />} />
      </div>
      { props.showEventQuestion ? renderEventQuestions() : '' }
      { props.hideButtons ? '' : renderFooter() }
    </form>
    )
}

ProfileForm = reduxForm({
  // a unique name for the form
  form: 'profile',
  validate, // sync validation
})(ProfileForm);

export default ProfileForm;
